// @flow
import cuckoo from "../cuckoo/cuckoo"
import { cuckooEvents } from "../../consts/enums"

export type ModalType =
  | ""
  | "abandonmentModal"
  | "chat"
  | "chatChat"
  | "cookies"
  | "creatingPassword"
  | "debug"
  | "delayedChat"
  | "errorModal"
  | "exponea"
  | "forgotPassword"
  | "login"
  | "maintenance"
  | "outdatedData"
  | "phoneNumbers"
  | "resetPassword"
  | "salesmanOnboarding"
  | "signUpConfirm"
  | "subscription"
  | "verifyEmail"
  | "verifyEmail"
  | "watchdog"
  | "watchdogLogin"

// eslint-disable-next-line flowtype/no-weak-types
export function showModal(modalType: ModalType, params?: Object) {
  return {
    type: "MODALS_SHOW",
    modalType,
    params,
  }
}

export function hideModal(modalType: ModalType) {
  return {
    type: "MODALS_HIDE",
    modalType,
  }
}

export function openChat(where: string, delayed: boolean) {
  cuckoo.track(cuckooEvents.GENERAL_OPEN_CHAT_CLICKED)
  cuckoo.infinario("chatOpened", { where })
  cuckoo.ga("General", "Chat", "Open")

  return showModal(delayed ? "delayedChat" : "chat")
}
